/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

export type PatientCPAInitialECGEnum =
  (typeof PatientCPAInitialECGEnum)[keyof typeof PatientCPAInitialECGEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientCPAInitialECGEnum = {
  VF: 'VF',
  VT: 'VT',
  PEA: 'PEA',
  ASYSTOLE: 'ASYSTOLE',
  OTHER: 'OTHER',
} as const;
